(() => {
  // Shopify inserts and re-renders these native consent dialogs asynchronously.
  const updatePolicyLinks = () => {
    document.querySelectorAll('#shopify-pc__banner a, #shopify-pc__prefs a').forEach((link) => {
      try {
        if (link.id === 'shopify-pc__banner__body-policy-link' || /\/policies\/privacy-policy\/?$/.test(new URL(link.href, location.origin).pathname)) {
          if (link.getAttribute('href') !== '/pages/policy') link.setAttribute('href', '/pages/policy');
        }
      } catch (_) {}
    });
  };
  // Keep the policy destination stable when Shopify replaces dialog markup.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('#shopify-pc__banner__body-policy-link, #shopify-pc__banner a, #shopify-pc__prefs a') : null;
    if (!link) return;
    let isPolicy = link.id === 'shopify-pc__banner__body-policy-link';
    try { isPolicy ||= /\/(?:policies\/privacy-policy|pages\/policy)\/?$/.test(new URL(link.href, location.origin).pathname); } catch (_) {}
    if (!isPolicy || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign('/pages/policy');
  }, true);
  updatePolicyLinks();
  new MutationObserver(updatePolicyLinks).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
})();
